import { installAnalytics } from './index';
installAnalytics(window);
